import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import GallerySectionImage from '../../assets/GallerySection/gallery-section.png'

export const GalleryPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Gallery section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={GallerySectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
